var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import middleware from './middleware';
import { createApp, NuxtError } from './index';
import { applyAsyncData, sanitizeComponent, resolveRouteComponents, getMatchedComponents, getMatchedComponentsInstances, flatMapComponents, setContext, middlewareSeries, promisify, getLocation, compile, getQueryDiff } from './utils';
var noopData = function () { return {}; };
var noopFetch = function () { };
var _lastPaths = [];
var app;
var router;
var store;
var NUXT = window.__NUXT__ || {};
createApp()
    .then(mountApp)
    .catch(function (err) {
    if (err.message === 'ERR_REDIRECT') {
        return;
    }
    console.error('[nuxt] Error while initializing app', err);
});
function componentOption(component, key) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (!component || !component.options || !component.options[key]) {
        return {};
    }
    var option = component.options[key];
    if (typeof option === 'function') {
        return option.apply(void 0, args);
    }
    return option;
}
function mapTransitions(Components, to, from) {
    var componentTransitions = function (component) {
        var transition = componentOption(component, 'transition', to, from) || {};
        return (typeof transition === 'string' ? { name: transition } : transition);
    };
    return Components.map(function (Component) {
        var transitions = Object.assign({}, componentTransitions(Component));
        if (from && from.matched.length && from.matched[0].components.default) {
            var from_transitions_1 = componentTransitions(from.matched[0].components.default);
            Object.keys(from_transitions_1)
                .filter(function (key) { return from_transitions_1[key] && key.toLowerCase().indexOf('leave') !== -1; })
                .forEach(function (key) { transitions[key] = from_transitions_1[key]; });
        }
        return transitions;
    });
}
function loadAsyncComponents(to, from, next) {
    return __awaiter(this, void 0, void 0, function () {
        var Components, startLoader, err_1, statusCode;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    this._pathChanged = !!app.nuxt.err || from.path !== to.path;
                    this._queryChanged = JSON.stringify(to.query) !== JSON.stringify(from.query);
                    this._diffQuery = (this._queryChanged ? getQueryDiff(to.query, from.query) : []);
                    if (this._pathChanged && this.$loading.start) {
                        this.$loading.start();
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, resolveRouteComponents(to)];
                case 2:
                    Components = _a.sent();
                    if (!this._pathChanged && this._queryChanged) {
                        startLoader = Components.some(function (Component) {
                            var watchQuery = Component.options.watchQuery;
                            if (watchQuery === true)
                                return true;
                            if (Array.isArray(watchQuery)) {
                                return watchQuery.some(function (key) { return _this._diffQuery[key]; });
                            }
                            return false;
                        });
                        if (startLoader && this.$loading.start) {
                            this.$loading.start();
                        }
                    }
                    next();
                    return [3, 4];
                case 3:
                    err_1 = _a.sent();
                    err_1 = err_1 || {};
                    statusCode = err_1.statusCode || err_1.status || (err_1.response && err_1.response.status) || 500;
                    this.error({ statusCode: statusCode, message: err_1.message });
                    this.$nuxt.$emit('routeChanged', to, from, err_1);
                    next(false);
                    return [3, 4];
                case 4: return [2];
            }
        });
    });
}
function applySSRData(Component, ssrData) {
    if (NUXT.serverRendered && ssrData) {
        applyAsyncData(Component, ssrData);
    }
    Component._Ctor = Component;
    return Component;
}
function resolveComponents(router) {
    var _this = this;
    var path = getLocation(router.options.base, router.options.mode);
    return flatMapComponents(router.match(path), function (Component, _, match, key, index) { return __awaiter(_this, void 0, void 0, function () {
        var _Component;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(typeof Component === 'function' && !Component.options)) return [3, 2];
                    return [4, Component()];
                case 1:
                    Component = _a.sent();
                    _a.label = 2;
                case 2:
                    _Component = applySSRData(sanitizeComponent(Component), NUXT.data ? NUXT.data[index] : null);
                    match.components[key] = _Component;
                    return [2, _Component];
            }
        });
    }); });
}
function callMiddleware(Components, context, layout) {
    var _this = this;
    var midd = [];
    var unknownMiddleware = false;
    if (typeof layout !== 'undefined') {
        midd = [];
        if (layout.middleware) {
            midd = midd.concat(layout.middleware);
        }
        Components.forEach(function (Component) {
            if (Component.options.middleware) {
                midd = midd.concat(Component.options.middleware);
            }
        });
    }
    midd = midd.map(function (name) {
        if (typeof name === 'function')
            return name;
        if (typeof middleware[name] !== 'function') {
            unknownMiddleware = true;
            _this.error({ statusCode: 500, message: 'Unknown middleware ' + name });
        }
        return middleware[name];
    });
    if (unknownMiddleware)
        return;
    return middlewareSeries(midd, context);
}
function render(to, from, next) {
    return __awaiter(this, void 0, void 0, function () {
        var nextCalled, _next, matches, Components, layout, layout, isValid_1, error_1, layout;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (this._pathChanged === false && this._queryChanged === false)
                        return [2, next()];
                    nextCalled = false;
                    _next = function (path) {
                        if (from.path === path.path && _this.$loading.finish)
                            _this.$loading.finish();
                        if (from.path !== path.path && _this.$loading.pause)
                            _this.$loading.pause();
                        if (nextCalled)
                            return;
                        nextCalled = true;
                        var matches = [];
                        _lastPaths = getMatchedComponents(from, matches).map(function (Component, i) { return compile(from.matched[matches[i]].path)(from.params); });
                        next(path);
                    };
                    return [4, setContext(app, {
                            route: to,
                            from: from,
                            next: _next.bind(this)
                        })];
                case 1:
                    _a.sent();
                    this._dateLastError = app.nuxt.dateErr;
                    this._hadError = !!app.nuxt.err;
                    matches = [];
                    Components = getMatchedComponents(to, matches);
                    if (!!Components.length) return [3, 5];
                    return [4, callMiddleware.call(this, Components, app.context)];
                case 2:
                    _a.sent();
                    if (nextCalled)
                        return [2];
                    return [4, this.loadLayout(typeof NuxtError.layout === 'function' ? NuxtError.layout(app.context) : NuxtError.layout)];
                case 3:
                    layout = _a.sent();
                    return [4, callMiddleware.call(this, Components, app.context, layout)];
                case 4:
                    _a.sent();
                    if (nextCalled)
                        return [2];
                    app.context.error({ statusCode: 404, message: 'This page could not be found' });
                    return [2, next()];
                case 5:
                    Components.forEach(function (Component) {
                        if (Component._Ctor && Component._Ctor.options) {
                            Component.options.asyncData = Component._Ctor.options.asyncData;
                            Component.options.fetch = Component._Ctor.options.fetch;
                        }
                    });
                    this.setTransitions(mapTransitions(Components, to, from));
                    _a.label = 6;
                case 6:
                    _a.trys.push([6, 11, , 13]);
                    return [4, callMiddleware.call(this, Components, app.context)];
                case 7:
                    _a.sent();
                    if (nextCalled)
                        return [2];
                    if (app.context._errored)
                        return [2, next()];
                    layout = Components[0].options.layout;
                    if (typeof layout === 'function') {
                        layout = layout(app.context);
                    }
                    return [4, this.loadLayout(layout)];
                case 8:
                    layout = _a.sent();
                    return [4, callMiddleware.call(this, Components, app.context, layout)];
                case 9:
                    _a.sent();
                    if (nextCalled)
                        return [2];
                    if (app.context._errored)
                        return [2, next()];
                    isValid_1 = true;
                    Components.forEach(function (Component) {
                        if (!isValid_1)
                            return;
                        if (typeof Component.options.validate !== 'function')
                            return;
                        isValid_1 = Component.options.validate({
                            params: to.params || {},
                            query: to.query || {},
                            store: store
                        });
                    });
                    if (!isValid_1) {
                        this.error({ statusCode: 404, message: 'This page could not be found' });
                        return [2, next()];
                    }
                    return [4, Promise.all(Components.map(function (Component, i) {
                            Component._path = compile(to.matched[matches[i]].path)(to.params);
                            Component._dataRefresh = false;
                            if (_this._pathChanged && Component._path !== _lastPaths[i]) {
                                Component._dataRefresh = true;
                            }
                            else if (!_this._pathChanged && _this._queryChanged) {
                                var watchQuery = Component.options.watchQuery;
                                if (watchQuery === true) {
                                    Component._dataRefresh = true;
                                }
                                else if (Array.isArray(watchQuery)) {
                                    Component._dataRefresh = watchQuery.some(function (key) { return _this._diffQuery[key]; });
                                }
                            }
                            if (!_this._hadError && _this._isMounted && !Component._dataRefresh) {
                                return Promise.resolve();
                            }
                            var promises = [];
                            var hasAsyncData = Component.options.asyncData && typeof Component.options.asyncData === 'function';
                            var hasFetch = !!Component.options.fetch;
                            var loadingIncrease = (hasAsyncData && hasFetch) ? 30 : 45;
                            if (hasAsyncData) {
                                var promise = promisify(Component.options.asyncData, app.context)
                                    .then(function (asyncDataResult) {
                                    applyAsyncData(Component, asyncDataResult);
                                    if (_this.$loading.increase)
                                        _this.$loading.increase(loadingIncrease);
                                });
                                promises.push(promise);
                            }
                            if (hasFetch) {
                                var p = Component.options.fetch(app.context);
                                if (!p || (!(p instanceof Promise) && (typeof p.then !== 'function'))) {
                                    p = Promise.resolve(p);
                                }
                                p.then(function (fetchResult) {
                                    if (_this.$loading.increase)
                                        _this.$loading.increase(loadingIncrease);
                                });
                                promises.push(p);
                            }
                            return Promise.all(promises);
                        }))];
                case 10:
                    _a.sent();
                    if (!nextCalled) {
                        if (this.$loading.finish)
                            this.$loading.finish();
                        _lastPaths = Components.map(function (Component, i) { return compile(to.matched[matches[i]].path)(to.params); });
                        next();
                    }
                    return [3, 13];
                case 11:
                    error_1 = _a.sent();
                    if (!error_1)
                        error_1 = {};
                    _lastPaths = [];
                    error_1.statusCode = error_1.statusCode || error_1.status || (error_1.response && error_1.response.status) || 500;
                    layout = NuxtError.layout;
                    if (typeof layout === 'function') {
                        layout = layout(app.context);
                    }
                    return [4, this.loadLayout(layout)];
                case 12:
                    _a.sent();
                    this.error(error_1);
                    this.$nuxt.$emit('routeChanged', to, from, error_1);
                    next(false);
                    return [3, 13];
                case 13: return [2];
            }
        });
    });
}
function normalizeComponents(to, ___) {
    flatMapComponents(to, function (Component, _, match, key) {
        if (typeof Component === 'object' && !Component.options) {
            Component = Vue.extend(Component);
            Component._Ctor = Component;
            match.components[key] = Component;
        }
        return Component;
    });
}
function showNextPage(to) {
    if (this._hadError && this._dateLastError === this.$options.nuxt.dateErr) {
        this.error();
    }
    var layout = this.$options.nuxt.err ? NuxtError.layout : to.matched[0].components.default.options.layout;
    if (typeof layout === 'function') {
        layout = layout(app.context);
    }
    this.setLayout(layout);
}
function fixPrepatch(to, ___) {
    var _this = this;
    if (this._pathChanged === false && this._queryChanged === false)
        return;
    Vue.nextTick(function () {
        var matches = [];
        var instances = getMatchedComponentsInstances(to, matches);
        instances.forEach(function (instance, i) {
            if (!instance)
                return;
            if (instance.constructor._dataRefresh && _lastPaths[i] === instance.constructor._path && typeof instance.constructor.options.data === 'function') {
                var newData = instance.constructor.options.data.call(instance);
                for (var key in newData) {
                    Vue.set(instance.$data, key, newData[key]);
                }
            }
        });
        showNextPage.call(_this, to);
    });
}
function nuxtReady(_app) {
    window._nuxtReadyCbs.forEach(function (cb) {
        if (typeof cb === 'function') {
            cb(_app);
        }
    });
    if (typeof window._onNuxtLoaded === 'function') {
        window._onNuxtLoaded(_app);
    }
    router.afterEach(function (to, from) {
        Vue.nextTick(function () { return _app.$nuxt.$emit('routeChanged', to, from); });
    });
}
function mountApp(__app) {
    return __awaiter(this, void 0, void 0, function () {
        var Components, _app, layout, mount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    app = __app.app;
                    router = __app.router;
                    store = __app.store;
                    return [4, Promise.all(resolveComponents(router))];
                case 1:
                    Components = _a.sent();
                    _app = new Vue(app);
                    layout = NUXT.layout || 'default';
                    return [4, _app.loadLayout(layout)];
                case 2:
                    _a.sent();
                    _app.setLayout(layout);
                    mount = function () {
                        _app.$mount('#__nuxt');
                        Vue.nextTick(function () {
                            nuxtReady(_app);
                        });
                    };
                    _app.setTransitions = _app.$options.nuxt.setTransitions.bind(_app);
                    if (Components.length) {
                        _app.setTransitions(mapTransitions(Components, router.currentRoute));
                        _lastPaths = router.currentRoute.matched.map(function (route) { return compile(route.path)(router.currentRoute.params); });
                    }
                    _app.$loading = {};
                    if (NUXT.error)
                        _app.error(NUXT.error);
                    router.beforeEach(loadAsyncComponents.bind(_app));
                    router.beforeEach(render.bind(_app));
                    router.afterEach(normalizeComponents);
                    router.afterEach(fixPrepatch.bind(_app));
                    if (NUXT.serverRendered) {
                        mount();
                        return [2];
                    }
                    render.call(_app, router.currentRoute, router.currentRoute, function (path) {
                        if (!path) {
                            normalizeComponents(router.currentRoute, router.currentRoute);
                            showNextPage.call(_app, router.currentRoute);
                            mount();
                            return;
                        }
                        router.push(path, function () { return mount(); }, function (err) {
                            if (!err)
                                return mount();
                            console.error(err);
                        });
                    });
                    return [2];
            }
        });
    });
}



// WEBPACK FOOTER //
// ./.nuxt/client.js